import React from 'react'
import styles from './style.module.scss'
import { parse } from 'path'

export interface XProgressBarProps {
    progress: number
    segments: number
}

const XProgressBar: React.FC<XProgressBarProps> = (props: XProgressBarProps) => {
    const { progress, segments } = props

    const segmentWidth = `calc(100% / ${segments})`
    const progressBars = []

    const shouldDisplayPercentageLabel = (i, segmentProgress) => {
        const nextSegmentProgress = Math.min(100, Math.max(0, progress - (i + 1) * 100))
        return (
            (i === Math.floor(progress / 100) && segmentProgress > 0) ||
            (segmentProgress === 100 && nextSegmentProgress === 0) ||
            (i === segments - 1 && segmentProgress > 0)
        )
    }

    const valueToDisplay = (i, segmentProgress) => {
        const percentagePerSegment = 100 / segments
        return (percentagePerSegment * i + (segmentProgress / 100) * percentagePerSegment).toFixed(0)
    }

    for (let i = 0; i < segments; i++) {
        const segmentProgress = Math.min(100, Math.max(0, progress - i * 100))

        const percentageToDisplay = parseInt(valueToDisplay(i, segmentProgress))

        const labelOffset = percentageToDisplay === 100 ? 35 : percentageToDisplay < 10 ? 20 : 25

        const labelPosition = `translateX(${segmentProgress - labelOffset}%)`

        progressBars.push(
            <div
                key={i}
                className={styles.xProgressBar__wrapper__container__progressBar}
                style={{ width: segmentWidth }}
            >
                <div
                    className={styles.xProgressBar__wrapper__container__progressBar__progress}
                    style={{ width: `${segmentProgress}%` }}
                />
                {shouldDisplayPercentageLabel(i, segmentProgress) && (
                    <div
                        className={styles.xProgressBar__wrapper__container__progressBar__progress__label}
                        style={{ transform: labelPosition }}
                    >
                        {`${percentageToDisplay}%`}
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className={styles.xProgressBar__wrapper}>
            <div className={styles.xProgressBar__wrapper__container}>{progressBars}</div>
        </div>
    )
}

export default XProgressBar
